import { numberMoney } from 'Data/format.js'

export function getAmount(entry) {
  return numberMoney(Math.abs(entry.transaction.amount))
}
